module.exports = __webpack_public_path__ + "img/qr_cm.e4642cfa.png";